import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Button from '../../../../../../common/widgets/Button';
import Icons from '../../../../../../common/widgets/Icons';
import { rewriteImageUrl } from '../../../../helpers';
import { BenefitProductModel } from '../../../../models/EmployeeBenefitInfoModel';
import {
  CanCancelSubscriptionTypes,
  SubscriptionItemModel,
} from '../../../../models/Subscriptions';
import { resources } from '../../../../resources/resources';
import CancelSubscriptionDialog from '../../../Common/CancelSubscriptionDialog';
import { BenefitInfoState } from '../BenefitInfoPage/BenefitInfoState';

interface ProductCartProps {
  orderId: number;
  product: BenefitProductModel;
  setState: Dispatch<SetStateAction<BenefitInfoState>>;
}

export default function ProductCart(props: Readonly<ProductCartProps>) {
  const { product, setState } = props;
  const { t: translate } = useTranslation();
  const [showConfirmDialog, setShowConfirmDialog] = useState<boolean>(false);

  const handleCancelSubscriptionClicked = () => {
    setShowConfirmDialog(true);
  };

  return (
    <div className="order-product">
      <div className="order-product-properties">
        <div className="order-product-image">
          <div>
            <Link to={`/products/${product.productId}`}>
              <img src={rewriteImageUrl(product.imageUrl)} alt={product.name} />
            </Link>
          </div>
        </div>
        <div className="order-product-details">
          <h3>
            <Link to={`/products/${product.productId}`}>{product.name}</Link>
          </h3>
          {product.subscriptionPeriod && (
            <div className="order-product-subscription">
              <div
                className={`checkout-list-subscription ${
                  product.subscriptionExpired ? 'inactive' : 'active'
                }`}
              >
                <span className="checkout-list-subscription-label">
                  {translate(resources.orders.subscriptionPeriod)}
                </span>
                <span className="checkout-list-subscription-status">
                  {`${product.subscriptionPeriod}`}
                </span>
              </div>
            </div>
          )}
          {product.canCancelSubscription != null &&
            product.canCancelSubscription !==
              CanCancelSubscriptionTypes.Hide && (
              <Button
                className="btn btn-solid btn-sm"
                onClick={handleCancelSubscriptionClicked}
                disabled={
                  product.canCancelSubscription ===
                  CanCancelSubscriptionTypes.Disable
                }
                icon={<Icons.Subtract />}
              >
                <span className="btn-text">
                  {translate(
                    resources.admin.employeeBenefits.details.endSubscription,
                  )}
                </span>
              </Button>
            )}
        </div>
      </div>
      <ul className="order-product-info">
        {product.orderOptions?.map(oo => <li key={oo}>{oo}</li>)}
      </ul>
      {showConfirmDialog && (
        <CancelSubscriptionDialog
          product={
            {
              orderProductId: product.orderProductId,
              name: product.name,
              cancelType: product.cancelType,
            } as SubscriptionItemModel
          }
          onSuccess={() => {
            setState(s => {
              return {
                ...s,
                reload: s.reload ? 1 : s.reload! + 1,
              };
            });
          }}
          onClose={() => setShowConfirmDialog(false)}
          context="admin"
        />
      )}
    </div>
  );
}
